<template>
  <div>
    <div style="display: flex; justify-content: stretch; margin-top: 50px; margin-right: 50px">
      <div style="margin-left: 50px; flex: 1">
        Arbitri
        <b-form-select v-model="selectedTd" :options="computedTdList"></b-form-select>
      </div>
      <div>
        Fase
        <combo-or-label v-model="selectedPhase" :options="availablePhases"></combo-or-label>
      </div>
      <div>
        Serie
        <combo-or-label v-model="selectedSerie" :options="availableSeries"></combo-or-label>
      </div>

      <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="selectedGroups"
          :options="sectorsInSerie"
      ></b-form-checkbox-group>

    </div>
  </div>
</template>

<script>
import ComboOrLabel from "../components/lib/ComboOrLabel";
import {mapGetters} from "vuex";
import {get} from "@/lib/fetcher";

export default {
  name: "DirectorsMap",
  components: {ComboOrLabel},
  data() {
    return {
      selectedPhase: 0,
      selectedSerie: "",
      selectedGroups: [],
      directorAssistants: [],
      currentMap: [],
      selectedTd: ""
    };
  },
  computed: {
    ...mapGetters({
      sectors: 'tournament/sector',
      series: 'tournament/series',
    }),
    availablePhases() {
      return Object.keys(this.sectors.Phases);
    },
    availableSeries() {
      const that = this;
      return Object.keys(this.sectors.Phases[that.selectedPhase].Series)
          .map(key => {
            let serie = this.sectors.Phases[that.selectedPhase].Series[key];
            return {value: key, text: serie.Sigla + " - " + serie.Descrizione};
          }).sort((s1, s2) => s1.value - s2.value);
    },
    sectorsInSerie() {
      if (this.selectedSerie === "") {
        return []
      }

      const currentSession = this.sectors.Phases[this.selectedPhase].Series[this.selectedSerie].CurrentSession;

      return Object.entries(this.sectors.Phases[this.selectedPhase].Series[this.selectedSerie].Sessions[currentSession].Groups)
          .map(entry => {
            return { text: entry[1].Sigla, value: entry[0]}
          });
    },
    directorsDictionary() {
      return Object.fromEntries(this.directorAssistants.map(x => [x.Code, x.Name]));
    },
    computedTdList() {
      return this.directorAssistants.map(td => {
        return { text: td.Name, value: td.Code }
      });
    },
  },
  methods: {
    getTdPayload(index) {
      return this.directorAssistants[index].Code;
    },
    onDrop(collection, sectorId, dropResult) {
      const tdFullCode = dropResult.payload;
      const that = this;
      const tdArray = this.currentMap
          .filter(map => map.Series === that.selectedSerie)
          .find(map => map.Group == sectorId).DirectorsFullCode;

      tdArray.push({
        tdFullCode
      });
    },
    shouldAcceptDrop(collection, tdFullCode) {
      return !collection.includes(tdFullCode);
    },
    directorsInSector(sectorId) {
      const that = this;
      let filter = this.currentMap
          .filter(map => map.Series === that.selectedSerie)
          .filter(map => map.Group == sectorId);
      if (filter === undefined) {
        filter = {
          "Series": this.selectedSerie,
          "Group": sectorId,
          "DirectorsFullCode": []
        };
        this.currentMap.push(filter);
      }
      return filter
          .map(map => map.DirectorsFullCode);
    },
  },
  created() {
    get('/api/directors/list')
        .then(resp => {
          this.directorAssistants = resp;
        });
    get('/api/directors/map')
        .then(resp => {
          this.currentMap = resp;
        });

  }
}


</script>

<style scoped>

</style>
